<div class="container my-4">
    <div class="row">
        <div class="col-12 ">
            <span class="title_header_bar">
                <img style="position: absolute;left: 30px;top: 13px;" (click)="goToManagePromotionForm()"
                    src="assets/images/svg/back-button.svg" class="pointer img_sat" width="30px" height="30px">
                Banner Details
            </span>
        </div>
    </div>
    <div class="card card_content">
        <form [formGroup]="form">
            <div class="row">
                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Promotion</mat-label>
                        <input matInput  maxlength="50" formControlName="promotionName"
                            placeholder="Enter Promotion Name" required class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4">
                    <mat-checkbox formControlName="isForSubCategory" color="primary">Is For Sub-Category?</mat-checkbox>
                </div>
                <div class="col-sm-12 col-md-6 mt-4" *ngIf="!this.form.value.isForSubCategory">
                    <mat-form-field appearance="fill" style="width: 100%;" hideRequiredMarker>
                        <mat-label>Product Name</mat-label>
                        <mat-select formControlName="productDetailId" placeholder="Select Primary Product"
                            >
                            <input matInput placeholder="Search" />
                            <mat-optgroup *ngFor="let group of filteredGroupedProducts()"
                                [label]="group?.categoryName?.toUpperCase()">
                                <mat-option *ngFor="let product of group.products" [value]="product.id">
                                    {{ product?.aliasName?.toUpperCase() }}{{
                                    product?.productCategoryName?.toUpperCase() }}
                                </mat-option>
                            </mat-optgroup>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4" *ngIf="!this.form.value.isForSubCategory">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Promotion Price</mat-label>
                        <input matInput  maxlength="50" formControlName="PromoPrice"
                            placeholder="Enter Promotion Name"  class="col-12" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4" *ngIf="this.form.value.isForSubCategory">
                    <mat-form-field appearance="fill" hideRequiredMarker>
                        <mat-label>Sub Category Name</mat-label>
                        <mat-select class="scrollbarcs" formControlName="productSubCategoryId"
                            placeholder="Select Sub Category">
                            <mat-select-filter [displayMember]="'value'" [array]="subCategorylist"
                                (filteredReturn)="filteredList1 = $event"></mat-select-filter>
                            <mat-option *ngFor="let item of filteredList1" [value]="item.Id"
                                style="overflow-y: scroll !important;">
                                {{item.SubCategoryName}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-sm-12 col-md-6 mt-4 padd-right-file" style="display: flex;">
                    <mat-form-field appearance="fill" hideRequiredMarker (click)="selectFile()">
                        <mat-label>Promotion Image</mat-label>
                        <input matInput  id="imageName" placeholder="Select Attachment"
                            formControlName="imageName" autocomplete="off" specialIsAlphaNumeric class="col-10"
                            autocomplete="off" readonly>
                    </mat-form-field>
                    <div>
                        <button type="button" (click)="selectFile()" *ngIf="isFileSelected"
                            class="badge bg-light-blue image-button">
                           <img src="../../../../assets/Home-Connect/icons/upload-Icon.svg" style="width: 26px;"/>
                        </button>
                        <button type="button" (click)="reset()" *ngIf="!isFileSelected"
                            class="badge bg-light-blue image-button">
                            <img style="filter: invert(1);width: 26px;"
                                src="../../../../assets/Home-Connect/icons/delete.svg" />
                        </button>
                    </div>
                </div>
                <div class="col-sm-12 col-md-6 mt-4" [class]="this.form.value.isForSubCategory?'mb-4':''" *ngIf="promotionId==0">
                    <img id="bannerImage" alt="Banner Image" height="100" *ngIf="fileName" />
                </div>
                <div class="col-sm-12 col-md-6 mt-4" [class]="this.form.value.isForSubCategory?'mb-4':''" *ngIf="promotionId!=0">
                    <img id="bannerImage" alt="Banner Image" height="100"  />
                </div>
                <div class="col-sm-12 col-md-12" [class]="!this.form.value.isForSubCategory?'mt-4':'mt-0'">
                    <div class="row">
                        <div class="col-sm-12 col-md-6">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>Start Date</mat-label>
                                <input readonly matInput  [matDatepicker]="startDate"
                                    formControlName="startOnTs" selectable="isSelectable(date,type)" id="startDate"
                                    autocomplete="off" placeholder="Select From Date" class="custom-input-border"
                                    specialIsAlphaNumeric (click)="openStartDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="startDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #startDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                        <div class="col-sm-12 col-md-6">
                            <mat-form-field class="custom-input" appearance="fill" hideRequiredMarker>
                                <mat-label>End Date</mat-label>
                                <input readonly matInput  [matDatepicker]="endDate"
                                    formControlName="expiredOnTs" selectable="isSelectable(date,type)" id="endDate"
                                    autocomplete="off" [min]="toMinDate" [max]="toMaxDate" placeholder="Select To Date"
                                    class="custom-input-border" specialIsAlphaNumeric (click)="openEndDateDatePicker()">
                                <mat-datepicker-toggle matSuffix [for]="endDate" style="color:black;">
                                    <button mat-icon-button>
                                        <mat-icon>event</mat-icon>
                                    </button>
                                </mat-datepicker-toggle>
                                <mat-datepicker #endDate></mat-datepicker>
                            </mat-form-field>
                        </div>
                    </div>
                </div>
            </div>
            <div class="d-flex justify-content-center button-style">
                <button class="btn btn-secondary mb-3 mt-5 mr-4" matButton (click)="save()">{{promotionId ===0?'Save':
                    'Update'}}</button>
                <button class="btn btn-primary mb-3 mt-5" matButton (click)="goToManagePromotionForm()">Cancel</button>

            </div>
        </form>
    </div>
</div>
